import TextField from '@mui/material/TextField'

const OutlinedField = ({ sx, ...props }: React.ComponentProps<typeof TextField>) => {
  return (
    <TextField
      sx={{
        width: '100%',
        borderRadius: '4px',
        '& .MuiFormHelperText-root': {
          marginLeft: '0px',
          '@media (max-width: 480px)': {
            fontSize: '12px',
          },
          '@media (max-width: 800px)': {
            fontSize: '13px',
          },
        },
        '& .MuiInputBase-input': {
          padding: '10px 16px 10px 16px',
          color: 'primary.main',
          fontWeight: 400,
          fontSize: '1rem',
          '@media (max-width: 480px)': {
            padding: '8px 12px',
            fontSize: '14px',
          },
          '@media (max-width: 800px)': {
            padding: '9px 14px',
            fontSize: '15px',
          },
        },
        '& .MuiInputBase-input::placeholder': {
          color: 'primary.main',
          fontWeight: 400,
          fontSize: '1rem',
          '@media (max-width: 480px)': {
            fontSize: '14px',
          },
          '@media (max-width: 800px)': {
            fontSize: '15px',
          },
        },
        '& .MuiInputLabel-root': {
          '@media (max-width: 480px)': {
            fontSize: '14px',
          },
          '@media (max-width: 800px)': {
            fontSize: '15px',
          },
        },
        '& .MuiInputBase-root.MuiOutlinedInput-root .MuiOutlinedInput-notchedOutline': {
          borderColor: 'primary.lighter',
        },

        ' & .MuiInputBase-root.Mui-focused .MuiOutlinedInput-notchedOutline': {
          borderColor: 'primary.light',
          borderWidth: '1px',
        },
        '& .MuiInputBase-root.Mui-error .MuiOutlinedInput-notchedOutline': {
          borderColor: 'error.main',
        },

        ...sx,
      }}
      {...props}
    />
  )
}

export default OutlinedField
